import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { WccIntegrationStatusType } from '@shared/enums/wcc-integration-status-type.enum';
import { ShipmentCreationTemplateTypes } from '@shared/enums/shipment-creation-template-types.enum';
import { ShipmentStatus } from '@shared-features/enums/shipment-status.enum';
import { ShipmentCreationType } from '@features/shipments/enums/shipment-creation-type.enum';
import { VendorSource } from '@shared-features/enums/vendor-source.enum';
import { CustomerType } from '@shared/enums/customer-type.enum';
import { ShipmentDirection } from '@features/shipments/enums/shipment-direction.enum';

export class ShipmentList extends Model {
  @Expose() ReceiverId: number;
  @Expose() ReceiverName: string;
  @Expose() cost: number;
  @Expose() createdAt: number;
  @Expose() createdByFirstName: string;
  @Expose() createdByLastName: string;
  @Expose() creatorType: string;
  @Expose() customerId: number;
  @Expose() customerName: string;
  @Expose() customerType: CustomerType;
  @Expose() driverFirstName: string;
  @Expose() driverId: number;
  @Expose() driverLastName: string;
  @Expose() fleetId: number;
  @Expose() fleetName: string;
  @Expose() from: string;
  @Expose() id: number;
  @Expose() uuid: string;
  @Expose() iqamaId: string;
  @Expose() margin: number;
  @Expose() nonResidentId: number;
  @Expose() price: number;
  @Expose() to: string;
  @Expose() status: ShipmentStatus;
  @Expose() lastActionDate: number;
  @Expose() mobileNumber: number;
  @Expose() AssignedByFirstName: number;
  @Expose() AssignedByLastName: number;
  @Expose() AssignedByUserType: number;
  @Expose() deliveryNoteId: number;
  @Expose() hasDeliveryNote: number;
  @Expose() hasCompletedAttachments: number;
  @Expose() hasDynamicFields: boolean;
  @Expose() pickUpDate: number;
  @Expose() numberOfRequests: number;
  @Expose() googleDistance: number;
  @Expose() isAvlTrackingAvailable: boolean;
  @Expose() isMobileTrackingAvailable: boolean;
  @Expose() labels: string;
  @Expose() notes: string;
  @Expose() product: string;
  @Expose() trailerDoorNumber: string;
  @Expose() truckPlateNumber: string;
  @Expose() truckTypeName: string;
  @Expose() shipmentCreationTemplate: ShipmentCreationTemplateTypes;
  @Expose() dropOffCustomerId: number;
  @Expose() dropOffCustomerName: string;
  @Expose() dropOffLocationAddress: string;
  @Expose() dropOffLocationName: string;
  @Expose() dropOffUserId: number;
  @Expose() dropOffUserName: string;
  @Expose() shipmentCreationType: ShipmentCreationType;
  @Expose() delayedAction: boolean;
  @Expose() wccIntegrationStatus: WccIntegrationStatusType;
  @Expose() driverAssignCount: boolean;
  @Expose() isCheckedIn: boolean;
  @Expose() hasTransactionChanges?: boolean;
  @Expose() deliveryDate: number;
  @Expose() isBroadcasted: boolean;
  @Expose() customerVendorSource: VendorSource;
  @Expose() isPaidForDriver: boolean;
  @Expose() noOfCustomers: number;
  @Expose() pickUpLocationName: string;
  @Expose() direction: ShipmentDirection;
}
